function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

import $ from 'jquery';
import 'remodal';

var initElement = function initElement(remodal) {
  var $remodal = $(remodal);
  $remodal.remodal({
    hashTracking: false,
    modifier: remodal.getAttribute('data-remodal-modifier') || 'remodal_default'
  });
};

var initAll = function initAll() {
  var nodes = document.querySelectorAll('.remodal');

  _toConsumableArray(nodes).forEach(function (node) {
    return initElement(node);
  });
};

var removeLockedClass = function removeLockedClass() {
  document.documentElement.classList.remove('remodal-is-locked');
};

var syncScrollbarPadding = function syncScrollbarPadding() {
  var padding = $('body').css('padding-right');
  $('.remodal-fixed-section').css('padding-right', padding);
};

var start = function start() {
  document.addEventListener('page:load', initAll);
  document.addEventListener('ajax:success', initAll);
  document.addEventListener('page:load', removeLockedClass);
  $(document).on('opening closed', '.remodal', syncScrollbarPadding);
};

export default {
  initAll: initAll,
  initElement: initElement,
  removeLockedClass: removeLockedClass,
  syncScrollbarPadding: syncScrollbarPadding,
  start: start
};